import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {getUserList} from '@/api/common'
import {delNullProperty} from "@/utils";

@Component({
    directives: {
        'el-select-loadmore': {
            // bind表示这个自定义指令一绑定到dom上，就开始自动执行
            bind(el: any, binding: any) {
                // 获取element-ui定义好的scroll盒子
                const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
                SELECTWRAP_DOM.addEventListener('scroll', function () {
                    /**
                     * scrollHeight 获取元素内容高度(只读)
                     * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                     * clientHeight 读取元素的可见高度(只读)
                     * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                     * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                     */
                        // console.log(el.scrollHeight, el.scrollTop, el.clientHeight)
                        //    this.scrollHeight = el.scrollHeight
                        //    this.scrollTop = el.scrollTop
                    const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                    if (condition) {
                        binding.value();
                    }
                });
            },
            // 表示dom插入到页面上的时候自动执行
            // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
            inserted(el, binding) {
                el.focus()
            },
            // 表示自定义指令后面的值更新的时候，自动执行
            update() {
                // console.log(this.scrollHeight, this.scrollTop, '11');
            }
        }
    }
})
export default class MoreUsersFilter extends Vue {
    @Prop() usersId: string | object[];
    @Prop() usersName: string | object[];
    @Prop() multiple: boolean; // 多选（B端客户，）
    @Prop() multipleLimit: number; // （审批节点配置）
    @Prop() style1: object; // （数据共享）
    @Prop() isDisibale: boolean; // 是否禁用 市场线索新建
    @Prop() isCheckbox: boolean; // 是否有复选框 市场线索新建
    @Prop() nameAngId: boolean; // 是否有复选框 市场线索新建

    allPage = 0
    page = 1
    limit = 20
    name = ''
    userList = []
    // 新增
    userId: string | object = null
    userName: string | object = null
    checked = false // 是否选中
    ids = []
    allCheck = false
    isIndeterminate = false

    changeUsers(e) {
        if (this.nameAngId) {
            this.$emit('changeUsers', {array: e})
        } else {
            const arr = []
            if (this.multiple) { // 多选
                e.forEach(item => {
                    this.userList.forEach(items => {
                        if (items.id === item) {
                            arr.push({
                                id: items.id,
                                realName: items.realName,
                                departmentName: items.departmentName,
                            })
                        }
                    })
                })
                this.$emit('changeUsers', {id: e, array: arr})
            } else { // 单选
                const UsersItem = (this.userList as any).filter(item => item.id === e)[0]
                this.$emit('changeUsers', (UsersItem || {id: e}))
            }
        }
    }



    loadmore() {
        this.page++
        this.getUserList();
    }


    // 计算属性 （同时监听两个值的变化）
    get userIdAndUserName() {
        const {usersId, usersName} = this
        return {
            usersId,
            usersName
        }
    }

    /*
    *
    * new
    * */

    async getUserList() {
        const data: any = await getUserList(delNullProperty({page: this.page, name: this.name}))
        this.userList = [...this.userList, ...data.userList]
        let result = []
        const obj = {}

        for (let i = 0; i < this.userList.length; i++) {
            if (!obj[this.userList[i].id]) {
                result.push(this.userList[i]);
                obj[this.userList[i].id] = true;
            }
        }
        if (typeof (this.usersName) == 'string') {
            if (this.usersName && this.userId && result.every(item => (item.id !== this.userId))) {
                result.push({
                    id: this.usersId,
                    realName: this.usersName,
                })
            }
        } else if (typeof (this.usersName) == 'object') {
            this.usersName.forEach((items: any) => {
                if (result.every(item => (item.id !== items.id))) {
                    result = [...result, ...[items]]
                }
            })

        }

        this.userList = result
    }


    async handleUser() {
        if ((this.userList.length == 0 || !this.name) && !this.userName) {
            this.name = null
            this.page = 1
            const result: any = await getUserList(delNullProperty({page: this.page, name: this.name}))
            this.userList = result.userList
        }
        if (this.userName) {
            this.userList = []
            this.page = 1
            const result: any = await getUserList(delNullProperty({page: this.page, name: this.userName}))
            this.userList = result.userList
        }
    }

    async remoteMethod(query: any) {
        this.name = query
        this.page = 1
        if (query !== '') {
            const result: any = await getUserList(delNullProperty({page: this.page, name: query}))
            this.userList = result.userList
        } else {
            this.userList = []
            this.getUserList();
        }
    }

    clearUser() {
        this.userId = null
        this.userName = null
        this.name = null
        this.page = 1
        this.getUserList()
    }

    /*
    * old*/


    @Watch('userIdAndUserName', {deep: true, immediate: true})
    handleWatchUserId(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            this.userId = newVal.usersId // 编辑详情回显
            this.userName = newVal.usersName ? newVal.usersName : '' // 编辑详情回显
            if (!this.userId || (this.userId as any).length === 0) {
                this.userName = ''
                return
            }
            this.getUserList()
        }
    }

}